import {useLogout} from "../lib/authentication";

const Logout = () => {
    const logout = useLogout();

    logout();

    return null;
};

export default Logout;